// extracted by mini-css-extract-plugin
module.exports = {"events-of-the-day":"eventsOfTheDay__events-of-the-day___30igc","container":"eventsOfTheDay__container___1RhcX","spinner":"eventsOfTheDay__spinner___1Eg5k"};